import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;
let cache = null;
let inflight = null;
const listeners = new Set();

const fetchSettings = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = axios.get(`${API}/api/public/ai-form-check/settings`, { withCredentials: true })
      .then(({ data }) => { cache = data; listeners.forEach((fn) => fn(data)); return data; })
      .catch(() => { cache = { public_visible: false }; return cache; })
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export const isStaffUser = (user) => !!user && (user.role === 'admin' || user.role === 'coach' || !!user.coach_portal_role);

/** Whether the AI Technique Review may be shown to the current visitor (public flag OR staff). */
export const useAIFormCheckVisibility = () => {
  const { user } = useAuth();
  const [settings, setSettings] = useState(cache);
  useEffect(() => {
    let alive = true;
    fetchSettings().then((d) => alive && setSettings(d));
    const fn = (d) => alive && setSettings(d);
    listeners.add(fn);
    return () => { alive = false; listeners.delete(fn); };
  }, []);
  const staff = isStaffUser(user);
  const publicVisible = !!settings?.public_visible;
  return { loaded: !!settings, publicVisible, isStaff: staff, visible: publicVisible || staff, staffPreview: staff && !publicVisible, settings };
};

export const refreshAIFormCheckVisibility = () => { cache = null; return fetchSettings(); };
